<template>
	<div>
		<div
			style="
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 16px;
				padding: 12px 20px 0px;
			"
		>
			<div style="color: #07111b"></div>
			<div style="font-size: 18px; font-weight: bold">{{ $t('order.invoice') }}</div>
			<div style="color: #07111b" @click="applyInvoice">{{ $t('general.apply') }}</div>
		</div>
		<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
		<div>
			<cube-radio-group class="radioStyle" style="padding: 0px 10px">
				<div v-for="(invoice, idx) in invoiceList" :key="idx">
					<div
						style="
							display: flex;
							justify-content: space-between;
							align-items: center;
							padding-right: 20px;
						"
					>
						<div>
							<cube-radio :option="invoice" v-model="selectedInvoice" :key="idx">
								<div style="font-size: 15px; margin-left: 18px">
									<div>{{ invoiceType(invoice.invoice_state) }}</div>
									<div>{{ invoiceContent(invoice) }}</div>
								</div>
							</cube-radio>
						</div>
					</div>
					<div v-if="idx != invoiceList.length - 1" style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
				</div>
			</cube-radio-group>
			<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
			<div style="padding: 10px 55px; font-size: 16px" @click="$router.push({name: 'MemberInvoiceList'})">
				<span style="color: #07111b">+</span>
				<span style="margin-left: 10px">{{ $t('invoice.new') }}</span>
			</div>
			<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex"
import { Toast, Indicator } from 'mint-ui'
import { getInvoiceList, defaultInvoice } from '../../../../api/memberInvoice'

export default {
	data() {
		return {
			invoiceList: [],
			invoiceListFirst: {
				is_default: 0,
				invoice_state: 0
			},
			selectedInvoice: 0,
			floor: "",
			company: "",
			note: "",
			checkerValue: [],
		};
	},
	created: function () {
		this.getInvoiceList()
	},
	methods: {
		...mapActions({
			setInvoice: "setInvoice",
		}),
		closeDialog() {
			this.setInvoice(false);
		},
		getInvoiceList() {
			let _this = this
			getInvoiceList().then(res => {
				this.invoiceList = res.result.invoice_list
				this.invoiceList.unshift(this.invoiceListFirst)
				let self = this
				this.invoiceList.forEach(function(invoice, idx) {
					invoice.value = idx    // radio button value
					if (invoice.is_default == 1) {
						_this.$emit('updateInvoice', invoice)
						self.selectedInvoice = idx
					}
				})
				if (this.selectedInvoice == 0) {
					this.$emit('updateInvoice', this.invoiceList[0])
				}
			}).catch(function (error) {
				Toast(error.message)
			})
		},
		applyInvoice() {
			let invoice = this.invoiceList[this.selectedInvoice]
			if (this.selectedInvoice !== 0) {
				invoice.is_default = 1
				defaultInvoice(invoice.invoice_id).then((response) => {
					Indicator.close()
					this.$emit('updateInvoice', invoice)
					this.closeDialog()
					// this.getInvoiceList()
				}, (error) => {
					Indicator.close()
					Toast(error.message)
				})
			} else {
				this.$emit('updateInvoice', invoice)
				this.closeDialog()
			}
		},
		invoiceType(invoice_state) {
			if (invoice_state == 0) {
				return this.$t('invoice.platform_carrier')
			}
			else if (invoice_state == 1) {
				return this.$t('invoice.carrier')
			}
			else if (invoice_state == 2) {
				return this.$t('invoice.tax_id_number')
			}
		},
		invoiceContent(invoice) {
			if (invoice.invoice_state == 0) {
				return this.$t('invoice.platform_carrier_note')
			}
			else if (invoice.invoice_state == 1) {
				return invoice.invoice_code
			}
			else if (invoice.invoice_state == 2) {
				return `${invoice.invoice_company_code} ${invoice.invoice_company}`
			}
			else {
				return ''
			}
		}
	},
};
</script>

<style scoped>
.radioStyle >>> .border-top-1px,
.border-right-1px,
.border-bottom-1px,
.border-left-1px {
	position: inherit !important;
}

.card {
	margin: 10px 0px;
	border: 1px solid darkgray;
	box-shadow: 0px 1px 8px rgb(8, 6, 6);
	padding: 15px;
	border-radius: 10px;
}

.inlineCard {
	font-size: 12px;
	line-height: 16px;
	color: #b0aeae;
	border: 2px solid #e1e1e1;
	border-radius: 6px;
}
.footer {
	position: fixed;
	bottom: 0;
	width: 100%;
	height: 80px;
	background-color: #ffffff;
	box-shadow: 0 4px 10px 5px darkgrey;
}
.btnConfirm {
	margin: 15px;
	display: flex;
	justify-content: center;
	background-color: #2c3b53;
	border-radius: 8px;
	color: white;
	align-items: center;
	padding: 13px 20px;
	box-shadow: 0px 1px 8px darkgrey;
}
.checkerStyle >>> .cube-checker-item {
	border: 1px solid darkgray;
	box-shadow: 0px 1px 8px rgb(8 6 6);
	border-radius: 15px;
	padding: 10px 35px;
	font-size: 16px;
	color: #2c3b53;
	margin-right: 0px;
	position: inherit;
}
.checkerStyle >>> .cube-checker-item_active {
	background-color: #2c3b53;
	color: white;
	border: none;
}
.checkerStyle {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
